import type { Theme } from '@mui/material';

export const styles = {
  barRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    paddingRight: 5,
  },
  bar: (theme: Theme, width: number) => ({
    background: theme.colors.secondary[500],
    height: 24,
    minWidth: 0,
    transition: 'width 0.3s',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    width: `${width}%`,
  }),
  barRest: (theme: Theme, width: number) => ({
    background: theme.colors.white,
    height: 24,
    minWidth: 0,
    borderRadius: 0,
    flexGrow: 1,
    width: `${width}%`,
  }),
  percentLabel: {
    ml: 1,
    fontWeight: 'bold',
    position: 'absolute',
    right: -40,
    top: '50%',
    transform: 'translateY(-50%)',
    whiteSpace: 'nowrap',
    fontSize: 14,
    zIndex: 1,
  },
};
